// import * as views from "../views";
// import { i18nFormat } from "@/i18n.js";
// import RouterView from "@/core/components/RouteContainer.vue";
/**
 *
 * @param {Boolean} visible
 * @param {Boolean} search
 * @param {String} title
 * @param {String} domain
 */
/* let meta = (
  visible = false,
  breadcrumb = null,
  title = "",
  subtitle = "",
  domain = null
) => ({
  headerVisible: visible,
  headerDescription: subtitle,
  headerTitle: title,
  headerDomain: domain,
  allowAutoSidebar: false,
  breadcrums: breadcrumb
});

export default [{
  path: "thank-you-page",
  component: views.Layout,
  meta: meta(),
  children: [{
      path: "",
      name: "ThankYouPage",
      component: views.Default,
      meta: meta(false)
    },
    // {
    //   path: "app/:app",
    //   name: "AppDetails",
    //   component: views.Default,
    //   meta: meta(true, false, [
    //     { name: i18n.t("generals.tutorials"), to: "Tutorials" },
    //     { name: i18n.t("generals.topics") }
    //   ])
    // }
  ]
}];
 */
/**
 * Hide thank you page & redirect to integrations
 */
export default [{
  path: "thank-you-page",
  redirect: 'integrations'
}];
